import Vue from 'vue'
import Router from 'vue-router'
import NavviewNew from './views/NavviewNew.vue'
import microApp from '@micro-zoe/micro-app'
import { microRoutes } from '@/views/micro/routes'
import { restUrls } from '@/api/rest/url'
import axios from 'axios'
import store from '@/store/store.js';
import $alert from '@/components/alert'
import _ from 'lodash'
import Cookies from 'js-cookie'
import { userInfo, domain, $notify } from './global'
// import PerformanceMonitoring from '@jd/performance-monitoring';
import {getCurrentSiteEnv} from '@/api/lib/stream'
import { addLog } from '@/api/lib/addLog.js'

const env = Cookies.get('lwms.env') || 'test';
// const performanceMonitoring = new PerformanceMonitoring({
//   sid: 'ce3041b6033245a8a506e0e36a916835',
//   pid: '9HwAEg@D2K1LqD.evgkLDeD',
//   appKey: 'lwms-web-online', // 待补充
//   userId: userInfo.userCode, //用户登录的用户标识
//   code: 'SGM_memory_crash'
// })

Vue.use(Router)

// 页面刷新进入时立即发起版本检测请求，拿到结果后赋值 window.__guidedPackIsV2
window.__guidedPackIsV2 = false
// 根据版本标记同步更新 localStorage 中 /guidedPack 标签的 tagsName
// 这样刷新页面从 localStorage 恢复标签时，读到的就是最新的标签名
const syncGuidedPackTagName = () => {
  try {
    const tags = JSON.parse(window.localStorage.getItem('tags'))
    if (!Array.isArray(tags)) return
    let changed = false
    tags.forEach(tag => {
      if (tag.path === '/guidedPack') {
        tag.tagsName = window.__guidedPackIsV2
          ? 'packingV2'
          : tag.curMenuInfo?.menuName || tag.curMenuInfo?.translation || tag.tagsName
        changed = true
      }
    })
    if (changed) {
      window.localStorage.setItem('tags', JSON.stringify(tags))
    }
  } catch (e) {
    // localStorage 解析失败时忽略
  }
}
const checkGuidedPackVersion = async () => {
  try {
    const res = await axios.get(`/index/checkVersion?v=${window.APP_VERSION}`)
    window.__guidedPackIsV2 = !!res?.data?.data?.inWhiteList
  } catch {
    window.__guidedPackIsV2 = false
  } finally {
    syncGuidedPackTagName()
  }
}
checkGuidedPackVersion()
// 根据 window.__guidedPackIsV2 动态加载引导打包页组件
// true 走重构版（guidedPackRefactor），false 走旧版
const loadGuidedPackComponent = async () => {
  await checkGuidedPackVersion()
  if (window.__guidedPackIsV2) {
    return import('./views/outbound/guidedPackRefactor/guidedPack.vue')
  }
  return import('./views/outbound/guidedPack/guidedPack.vue')
}

const curVersion = localStorage.getItem('isNewVersion')
let isNewVersion = localStorage.getItem('isNewVersion') || '1'
const isManuallyTrigger = sessionStorage.getItem('isManuallyTrigger')
if (isNewVersion === '0' && !isManuallyTrigger) {
  localStorage.setItem('isNewVersion', '1')
  isNewVersion = '1'
}
// 选择旧版后刷新进入 默认还是新版
sessionStorage.removeItem('isManuallyTrigger');

// 旧版菜单壳（Navview.vue）已随菜单 manifest 重构下线，固定使用新版布局 NavviewNew
const Layout = NavviewNew
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre') {
  try {
    console.log('tracker', curVersion === '1' ? '新版' : '老版', userInfo.warehouseNo)
    window.log && window.log('iWMS', 'api|menu|version', JSON.stringify({
      isNewVersion: curVersion,
      name: curVersion === '1' ? '新版' : '老版',
      warehouseNo: userInfo.warehouseNo,
      userCode: userInfo.userCode
    }))
  } catch (error) {
    console.log(error)
  }
}
// 旧 hash 链接 / 历史脏 URL 的改写已前移到 public/index.html 的内联脚本
// （在 Vue/router 加载前执行），此处不再处理，路由只按 history pathname 匹配。
const router = new Router({
  mode: 'history',
  // 应用部署在域名根路径（静态资源走独立的版本化 CDN 路径，与路由 base 无关），故 base 固定为 '/'
  base: '/',
  routes: [
    {
      path: '/',
      name: '',
      redirect: '/index',
      //component: () => import('./views/Index.vue')
    },
    {
      path: '/Navview',
      component: Layout,
      children: [
        // 微前端子应用宿主路由（micro-app），统一收在 @/views/micro/routes
        ...microRoutes,
        // smartQuery
        // 测试例子 /smartQuery/wms_ib_receive_ysjy
        {
          path: '/index',
          name: 'index',
          component: () => import('./views/Index.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        // 库存流水快照查询
        {
          path: '/smartQuery/flowingQuery',
          name: 'flowingQuery',
          component: () => import('./views/flowingQuery/flowingQuery.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/asyncDownload',
          name: 'asyncDownload',
          component: () => import('./views/flowingQuery/asyncDownload.vue'),
          meta: {
            code: 'ASYNC-TASK-asyncDownload',
            newCode: 'iWMS-ASYNC-TASK-asyncDownload',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/createExportTask',
          name: 'createExportTask',
          component: () => import('./views/flowingQuery/createExportTask.vue'),
          meta: {
            code: 'ASYNC-TASK-createExportTask',
            newCode: 'iWMS-ASYNC-TASK-createExportTask',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/inventoryStockOutCheck',
          name: 'inventoryStockOutCheck',
          component: () => import('./views/inventoryComparison/inventoryStockOutCheck.vue'),
          meta: {
            code: 'INVENTORY-STOCK-OUT-CHECK',
            newCode: 'iWMS-INVENTORY-STOCK-OUT-CHECK',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/smartQuery/robotZoneStockCompare',
          name: 'robotZoneStockCompare',
          component: () => import('./views/inventoryComparison/robotZoneStockCompare.vue'),
          meta: {
            code: 'ROBOT-ZONE-STOCK-COMPARE',
            newCode: 'iWMS-ROBOT-ZONE-STOCK-COMPARE',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/ownerDaybook',
          name: 'ownerDaybook',
          component: () => import('./views/flowingQuery/ownerDaybook.vue'),
          meta: {
            code: 'HISTORY-BIZ-ownerDaybook',
            newCode: 'iWMS-HISTORY-BIZ-ownerDaybook',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/hourlyHumanEffect',
          name: 'HourlyHumanEffect',
          component: () => import('./views/flowingQuery/humanEfficiency/Summary.vue'),
          meta: {
            code: 'PERFORMANCE-OB-wms_ob_hourlyHumanEffect',
            newCode: 'iWMS-HISTORY-OB-hourlyHumanEffect',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/nonStandardManage',
          name: 'nonStandardManage',
          component: () => import('./views/flowingQuery/nonStandardManage/NonStandardManage.vue'),
          meta: {
            code: 'LWMS-NON-STANDARD-IMPORT-MANAGEMENT',
            newCode: 'iWMS-NON-STANDARD-IMPORT-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/smartQuery/stockBacklog',
          name: 'StockBacklog',
          component: () => import('./views/flowingQuery/stockBacklog/StockBacklog.vue'),
          meta: {
            code: 'LWMS-NON-STANDARD-IMPORT-MANAGEMENT',
            newCode: 'iWMS-NON-STANDARD-IMPORT-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        // {
        //   path: '/smartQuery/humanDashboard',
        //   name: 'humanDashboard',
        //   component: () => import('./views/flowingQuery/humanDashboard/humanDashboard.vue'),
        //   meta: {
        //     code: 'LWMS-HUMAN-DASHBOARD',
        //     newCode: 'iWMS-HUMAN-DASHBOARD',
        //     cache: true,
        //     intermediate: true,
        //   }
        // },
        {
          path: '/smartQuery/:functionId',
          name: 'smartQuery',
          component: () => import('./views/highOrderQuery/Report.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/monthlyExport',
          name: 'monthlyExport',
          component: () => import('./views/highOrderQuery/MonthlyExport.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/humanDashboard',
          name: 'humanDashboard',
          component: () => import('./views/flowingQuery/humanDashboard/index.vue'),
          meta: {
            code: 'LWMS-HUMAN-DASHBOARD',
            newCode: 'iWMS-HUMAN-DASHBOARD',
            cache: true,
            intermediate: true,
          }
        },
        // 历史数据菜单挂到谷歌云环境
        {
          path: '/historyQuery/:functionId',
          name: 'historyQuery',
          component: () => import('./views/highOrderQuery/HistoryReport.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },

        /** *入库模块 开始***/
        {
          path: '/scan',
          name: 'scan',
          component: () => import('./views/inbound/Scan.vue'),
          meta: {
            code: 'LWMS-PRE-INSPECTION',
            newCode: 'iWMS-PRE-INSPECTION',
            parentPaths: ['/scanContainer', '/scanGoodsInit', '/it01Acceptance','/it03Acceptance', '/it12Acceptance', '/it17Acceptance', '/it18Acceptance', '/it19Acceptance','/it20Acceptance', '/returnParcelTransfer', '/completeOrder'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['scanContainer', 'scanGoodsInit', 'it01Acceptance','it03Acceptance', 'it12Acceptance', 'it17Acceptance', 'it18Acceptance', 'it19Acceptance','it20Acceptance',  'returnParcelTransfer', 'completeOrder']
          }
        },
        /** 创建售后入库单 **/
        {
          path: '/createAfterSalesOrder',
          name: 'createAfterSalesOrder',
          component: () => import('./views/inbound/CreateAfterSalesOrder.vue'),
          meta: {
            code: 'LWMS-CREATE-AFTER-SALES-ORDER',
            newCode: 'iWMS-CREATE-AFTER-SALES-ORDER',
            cache: true,
            intermediate: false,
          }
        },
        /** R项目Ka创建售后入库单 **/
        {
          path: '/createKaAfterSalesOrder',
          name: 'createKaAfterSalesOrder',
          component: () => import('./views/inbound/CreateKaAfterSalesOrder.vue'),
          meta: {
            code: 'LWMS-CREATE-KA-AFTER-SALES-ORDER',
            newCode: 'iWMS-CREATE-KA-AFTER-SALES-ORDER',
            cache: true,
            intermediate: false
          }
        },
        /*** 无主包裹***/
        {
          path: '/unknownPackage',
          name: 'unknownPackage',
          component: () => import('./views/inbound/UnknownPackage.vue'),
          meta: {
            code: 'LWMS-BIZ-UNKNOWN-PACKAGE',
            newCode: 'iWMS-BIZ-UNKNOWN-PACKAGE',
            cache: true,
            intermediate: false,
          }
        },
        /*** 合单验收 ***/
        {
          path: '/orderCombine',
          name: 'orderCombine',
          component: () => import('./views/inbound/OrderCombine.vue'),
          meta: {
            code: 'LWMS-PURCHASE-ORDER-COMBINE',
            newCode: 'iWMS-PURCHASE-ORDER-COMBINE',
            cache: true,
            intermediate: true,
          }
        },
        /***耗材库存异常***/
        {
          path: '/consStockException',
          name: 'consStockException',
          component: () => import('./views/exception/outbound/consStockException.vue'),
          meta: {
            code: 'LWMS-BIZ-CONS-STOCK-EXCEPTION',
            newCode: 'iWMS-BIZ-CONS-STOCK-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/putawayExceptionTransfer',
          name: 'putawayExceptionTransfer',
          component: () => import('./views/inbound/PutawayExceptionTransfer.vue'),
          meta: {
            code: 'LWMS-PUTAWAY-EXCEPTION-TRANSFER',
            newCode: 'iWMS-PUTAWAY-EXCEPTION-TRANSFER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/putawayExceptionProcess',
          name: 'putawayExceptionProcess',
          component: () => import('./views/inbound/PutawayExceptionProcess.vue'),
          meta: {
            code: 'LWMS-PUTAWAY-EXCEPTION-PROCESS',
            newCode: 'iWMS-PUTAWAY-EXCEPTION-PROCESS',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receiptPrint',
          name: 'receiptPrint',
          component: () => import('./views/inbound/ReceiptPrint.vue'),
          meta: {
            code: 'LWMS-RECEIPT-PRINT',
            newCode: 'iWMS-RECEIPT-PRINT',
            intermediate: false
          }
        },
        {
          path: '/newPurchaseOrder',
          name: 'newPurchaseOrder',
          component: () => import('./views/inbound/NewPurchaseOrder.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/scanContainer',
          name: 'scanContainer',
          component: () => import('./views/inbound/ScanContainer.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scan', '/completeOrder', '/scanGoodsInit', '/it01Acceptance','/it03Acceptance', '/it12Acceptance', '/it17Acceptance', '/it18Acceptance', '/it19Acceptance','/it20Acceptance'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scan', 'completeOrder', 'scanGoodsInit', 'it01Acceptance', 'it03Acceptance', 'it12Acceptance', 'it17Acceptance', 'it18Acceptance', 'it19Acceptance','it20Acceptance']
          }
        },
        {
          path: '/returnParcelTransfer',
          name: 'returnParcelTransfer',
          component: () => import('./views/inbound/ReturnParcelTransfer.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scan'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scan']
          }
        }, {
          path: '/completeBooking',
          name: 'completeBooking',
          component: () => import('./views/inbound/CompleteBooking.vue'),
          meta: {
            code: 'LWMS-COMPLETE-BOOKING',
            newCode: 'iWMS-COMPLETE-BOOKING',
            cache: true,
            intermediate: false,
            relatedPageNames: ['completeBooking']
          }
        },
        {
          path: '/scanGoodsInit',
          name: 'scanGoodsInit',
          component: () => import('./views/inbound/ScanGoodsInit.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it01Acceptance',
          name: 'it01Acceptance',
          component: () => import('./views/inbound/It01Acceptance.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it12Acceptance',
          name: 'it12Acceptance',
          component: () => import('./views/inbound/it12Acceptance.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
            path: '/it20Acceptance',
            name: 'it20Acceptance',
            component: () => import('./views/inbound/It20Acceptance.vue'),
            meta: {
              code: '',
              newCode: '',
              parentPaths: ['/scanContainer'],
              cache: true,
              intermediate: true,
              relatedPageNames: ['scanContainer']
            }
         },
        {
          path: '/it03Acceptance',
          name: 'it03Acceptance',
          component: () => import('./views/inbound/It03Acceptance.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it17Acceptance',
          name: 'it17Acceptance',
          component: () => import('./views/inbound/It17Acceptance.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it18Acceptance',
          name: 'it18Acceptance',
          component: () => import('./views/inbound/It18Acceptance.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it19Acceptance',
          name: 'it19Acceptance',
          component: () => import('./views/inbound/It19Acceptance.vue'),
          meta: {
            code: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/it19Acceptance',
          name: 'it19Acceptance',
          component: () => import('./views/inbound/It19Acceptance.vue'),
          meta: {
            code: '',
            parentPaths: ['/scanContainer'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/itemsDetail',
          name: 'itemsDetail',
          component: () => import('./views/inbound/ItemsDetail.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true,
          }
        },
        {
          path: '/completeOrder',
          name: 'completeOrder',
          component: () => import('./views/inbound/CompleteOrder.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanContainer','/reverseAcceptance'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanContainer']
          }
        },
        {
          path: '/scanTrackingNo',
          name: 'scanTrackingNo',
          component: () => import('./views/inbound/ScanTrackingNo.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanTrackingNoDetail'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanTrackingNoDetail']
          }
        },
        {
          path: '/scanTrackingNoDetail',
          name: 'scanTrackingNoDetail',
          component: () => import('./views/inbound/ScanTrackingNoDetail.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/scanTrackingNo'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['scanTrackingNo']
          }
        },
        /*逆向入库分拨组波*/
        {
          path: '/receivingWaveGrouping',
          name: '/receivingWaveGrouping',
          component: () => import('./views/inbound/AllocateGroupWave.vue'),
          meta: {
            code: 'LWMS-RECEIVING-WAVE-GROUPING',
            newCode: 'iWMS-RECEIVING-WAVE-GROUPING',
            cache: true,
            intermediate: true,
          }
        },
        /*逆向验收*/
        {
          path: '/reverseAcceptance',
          name: 'reverseAcceptance',
          component: () => import('./views/inbound/reverseAcceptance'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        /*模拟验收工具*/
        {
          path: '/mockAcceptanceTool',
          name: '/mockAcceptanceTool',
          component: () => import('./views/inbound/MockAcceptanceTool.vue'),
          meta: {
            code: 'LWMS-RECEIVING-MOCKTOOL',
            newCode: 'iWMS-RECEIVING-MOCKTOOL',
            cache: true,
            intermediate: true,
          }
        },
        /*模拟验收工具*/
        {
          path: '/mockInboundTool',
          name: '/mockInboundTool',
          component: () => import('./views/inbound/MockInboundTool.vue'),
          meta: {
            code: 'LWMS-RECEIVING-MOCKTOOL',
            newCode: 'iWMS-RECEIVING-MOCKTOOL',
            cache: true,
            intermediate: true,
          }
        },
        /*上架策略*/
        {
          path: '/putawayStrategy',
          name: 'PutawayStrategy',
          component: () => import('./views/inbound/putawayStrategy/index.vue'),
          meta: {
            code: 'LWMS-INBOUND-PUTAWAY-STRATEGY',
            newCode: 'iWMS-INBOUND-PUTAWAY-STRATEGY',
            cache: true,
            intermediate: true,
            parentPaths: ['/putawayStrategyForm'],
            relatedPageNames: ['PutawayStrategyForm']
          }
        },
        {
          path: '/putawayStrategyForm',
          name: 'PutawayStrategyForm',
          component: () => import('./views/inbound/putawayStrategy/components/StrategyForm.vue'),
          meta: {
            code: 'LWMS-INBOUND-PUTAWAY-STRATEGY',
            newCode: 'iWMS-INBOUND-PUTAWAY-STRATEGY',
            cache: true,
            intermediate: true,
            parentPaths: ['/putawayStrategy'],
            relatedPageNames: ['PutawayStrategy']
          }
        },
        /** *入库模块 结束***/
        /** *在库模块 开始***/
        {
          path: '/checkStockOrderList',
          name: 'checkStockOrderList',
          component: () => import('./views/invop/CheckStockOrderList.vue'),
          meta: {
            code: 'LWMS-CHECK-STOCK-ORDER-LIST',
            // parentPaths: ['/createInventory', '/taskAllocation', '/inventoryConfirm'],
            newCode: 'iWMS-CHECK-STOCK-ORDER-LIST',
            cache: true,
            intermediate: false,
            // relatedPageNames: ['createInventory', 'taskAllocation', 'inventoryConfirm']
          }
        },
        {
          path: '/createInventory',
          name: 'createInventory',
          component: () => import('./views/invop/CreateInventory.vue'),
          meta: {
            // code: 'iWMS-CREATE-INVENTORY',
            code: '',
            newCode: 'iWMS-CREATE-INVENTORY',
            // parentPaths: ['/checkStockOrderList','/stockSearch'],
            cache: false,
            intermediate: true,
            // relatedPageNames: ['checkStockOrderList','stockSearch']
          }
        },
        {
          path: '/inventoryConfirm',
          name: 'inventoryConfirm',
          component: () => import('./views/invop/InventoryConfirm.vue'),
          meta: {
            code: 'iWMS-INVENTORY-CONFIRM',
            newCode: 'iWMS-INVENTORY-CONFIRM',
            // code: '',
            // newCode: '',
            // parentPaths: ['/checkStockOrderList'],
            cache: false,
            intermediate: true,
            // relatedPageNames: ['checkStockOrderList']
          }
        },
        {
          path: '/taskAllocation',
          name: 'taskAllocation',
          component: () => import('./views/invop/TaskAllocation.vue'),
          meta: {
            code: 'iWMS-INVENTORY-ASSIGN',
            newCode: 'iWMS-INVENTORY-ASSIGN',
            // code: '',
            // newCode: '',
            // parentPaths: ['/checkStockOrderList'],
            cache: false,
            intermediate: true,
            // relatedPageNames: ['checkStockOrderList']
          }
        },
        {
          path: '/differProcess',
          name: 'differProcess',
          component: () => import('./views/invop/DifferProcess.vue'),
          meta: {
            code: 'LWMS-DIFFERENCE-CENTER',
            newCode: 'iWMS-DIFFERENCE-CENTER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/profitLossApplyList',
          name: 'profitLossApplyList',
          component: () => import('./views/invop/ProfitLossApplyList.vue'),
          meta: {
            code: 'LWMS-PROFIT-LOSS-OPERATION',
            newCode: 'iWMS-PROFIT-LOSS-OPERATION',
            parentPaths: ['/profitLossApplyDetail'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['profitLossApplyDetail']
          }
        },
        {
          path: '/profitLossApplyDetail',
          name: 'profitLossApplyDetail',
          component: () => import('./views/invop/ProfitLossApplyDetail.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/profitLossApplyList'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['profitLossApplyList']
          }
        },
        {
          path: '/profitLossAuditList',
          name: 'profitLossAuditList',
          component: () => import('./views/invop/ProfitLossAuditList.vue'),
          meta: {
            code: 'LWMS-PROFIT-LOSS-APPROVAL',
            newCode: 'iWMS-PROFIT-LOSS-APPROVAL',
            parentPaths: ['/profitLossAuditDetail'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['profitLossAuditDetail']
          }
        },
        {
          path: '/profitLossAuditDetail',
          name: 'profitLossAuditDetail',
          component: () => import('./views/invop/ProfitLossAuditDetail.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/profitLossAuditList'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['profitLossAuditList']
          }
        },
        {
          path: '/cycleInventory',
          name: 'cycleInventory',
          component: () => import('./views/invop/CycleInventory.vue'),
          meta: {
            code: 'LWMS-CYCLE-INVENTORY',
            newCode: 'iWMS-CYCLE-INVENTORY',
            parentPaths: ['/taskAssignment', '/diffManage', '/inventoryStatistics', '/inventoryDetail'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['taskAssignment', 'diffManage', 'inventoryStatistics', 'inventoryDetail']
          }
        },
        {
          path: '/diffManage',
          name: 'diffManage',
          component: () => import('./views/invop/DiffManage.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/cycleInventory'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['cycleInventory']
          }
        },
        {
          path: '/taskAssignment',
          name: 'taskAssignment',
          component: () => import('./views/invop/TaskAssignment.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/cycleInventory'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['cycleInventory']
          }
        },
        {
          path: '/inventoryStatistics',
          name: 'inventoryStatistics',
          component: () => import('./views/invop/inventoryStatistics.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/cycleInventory'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['cycleInventory']
          }
        },
        // {
        //   path: '/taskAssign',
        //   name: 'taskAssign',
        //   component: () => import('./views/outbound/TaskAssign.vue'),
        //   meta: {
        //     code: 'LWMS-TASKASSIGN',
        //     newCode: 'iWMS-TASKASSIGN',
        //     cache: true,
        //     intermediate: false,
        //   }
        // },
        {
          path: '/taskAssignNew',
          name: 'taskAssignNew',
          component: () => import('./views/outbound/TaskAssignNew.vue'),
          meta: {
            code: 'LWMS-TASKASSIGN-MANAGEMENT',
            newCode: 'iWMS-TASKASSIGN-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/manualPosition',
          name: 'manualPosition',
          component: () => import('./views/outbound/manualPosition/ManualPosition.vue'),
          meta: {
            code: 'LWMS-MANUAL-POSITION',
            newCode: 'iWMS-MANUAL-POSITION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/dynamicPickingTaskMgmt',
          name: 'dynamicTaskManagement',
          component: () => import('./views/outbound/pickingTaskManage/dynamicTaskManagement.vue'),
          meta: {
            code: 'iWMS-PICKING-DYNAMIC-MANAGEMENT',
            newCode: 'iWMS-PICKING-DYNAMIC-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/pickingTaskManagement',
          name: 'taskManagementTab',
          component: () => import('./views/outbound/pickingTaskManage/index.vue'),
          meta: {
            code: 'LWMS-PICKING-TASK-MANAGEMENT',
            newCode: 'iWMS-PICKING-TASK-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/paperOrderRemoval',
          name: 'paperOrderRemoval',
          component: () => import('./views/outbound/pickingTaskManage/paperOrderRemoval.vue'),
          meta: {
            code: 'LWMS-PAPER-ORDER-CONFIRM-REMOVAL',
            newCode: 'iWMS-PAPER-ORDER-CONFIRM-REMOVAL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/packageCallExceptionManagement',
          name: 'packageExceptManage',
          component: () => import('./views/outbound/packageExceptManage/indexWarp.vue'),
          meta: {
            code: 'LWMS-PACKAGE-CALL-EXCEPTION-MANAGEMENT',
            newCode: 'iWMS-PACKAGE-CALL-EXCEPTION-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/taskManage',
          name: 'taskManagementTab',
          component: () => import('./views/outbound/pickingTaskManage/index.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/batchingTaskManagement',
          name: 'batchingTaskManagement',
          component: () => import('./views/outbound/pickingTaskManage/batchingTaskManage.vue'),
          meta: {
            code: 'LWMS-BATCHING-BATCH-MANAGEMENT',
            newCode: 'iWMS-BATCHING-BATCH-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/manualTuiShipment',
          name: 'manualTuiShipment',
          component: () => import('./views/outbound/OneClickStockOut.vue'),
          meta: {
            code: 'LWMS-MANUAL-TUIShIPMENT',
            newCode: 'iWMS-MANUAL-TUIShIPMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/groupOrderRules',
          name: 'groupOrderRules',
          component: () => import('./views/outbound/taskAssign/groupOrderRules.vue'),
          meta: {
            code: 'LWMS-GROUP-ORDER-RULES-MANAGEMENT',
            newCode: 'iWMS-GROUP-ORDER-RULES-MANAGEMENT',
            cache: true,
            intermediate: true,
            relatedPageNames: ['addGroupOrderRule', 'detailGroupOrderRule'],
            parentPaths: ['/addGroupOrderRule', '/detailGroupOrderRule'],
          }
        },
        {
          path: '/dynamicMonitor',
          name: 'dynamicMonitor',
          component: () => import('./views/outbound/taskAssign/dynamicMonitor.vue'),
          meta: {
            code: 'LWMS-GROUP-ORDER-RULES-MANAGEMENT',
            newCode: 'iWMS-GROUP-ORDER-RULES-MANAGEMENT',
            cache: true,
            intermediate: true,
            relatedPageNames: ['addGroupOrderRule', 'detailGroupOrderRule'],
            parentPaths: ['/addGroupOrderRule', '/detailGroupOrderRule'],
          }
        },
        {
          path: '/addGroupOrderRule',
          name: 'addOrEditGroupOrderRule',
          component: () => import('./views/outbound/taskAssign/addGroupOrderRule.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
            parentPaths: ['/groupOrderRules'],
            relatedPageNames: ['groupOrderRules']
          }
        },
        {
          path: '/detailGroupOrderRule',
          name: 'detailGroupOrderRule',
          component: () => import('./views/outbound/taskAssign/detailGroupOrderRule.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
            parentPaths: ['/groupOrderRules'],
            relatedPageNames: ['groupOrderRules']
          }
        },
        {
          path: '/taskAssignManage',
          name: 'taskAssignManage',
          component: () => import('./views/outbound/taskAssign/taskAssign.vue'),
          meta: {
            code: 'LWMS-TASKASSIGN-MANAGEMENT',
            newCode: 'iWMS-TASKASSIGN-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/productAndTransManage',
          name: 'productFirstArrangeTrans',
          component: () => import('./views/outbound/productFirstManage/pfat.vue'),
          meta: {
            code: 'LWMS-PRODUCT-FIRST-ARRANGE-TRANS',
            newCode: 'iWMS-PRODUCT-FIRST-ARRANGE-TRANS',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/toBTaskAssign',
          name: 'toBTaskAssign',
          component: () => import('./views/outbound/b2b/ToBTaskAssign.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/toBConfirPickDiscrepancies',
          name: 'toBConfirPickDiscrepancies',
          component: () => import('./views/outbound/b2b/ToBConfirPickDiscrepancies.vue'),
          meta: {
            code: 'LWMS-2B-PICKING-DIFFERENCE-CONFIRMATION',
            newCode: 'iWMS-2B-PICKING-DIFFERENCE-CONFIRMATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/toBGoodsDeliver',
          name: 'toBGoodsDeliver',
          component: () => import('./views/outbound/b2b/ToBGoodsDeliver.vue'),
          meta: {
            code: 'LWMS-2B-SHIPPING',
            newCode: 'iWMS-2B-SHIPPING',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/toBPrint',
          name: 'toBPrint',
          component: () => import('./views/outbound/b2b/ToBPrint.vue'),
          meta: {
            code: 'LWMS-PRINT-2B',
            newCode: 'iWMS-PRINT-2B',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/repackagePrint',
          name: 'repackagePrint',
          component: () => import('./views/outbound/RepackagePrint.vue'),
          meta: {
            code: 'LWMS-PRINT-BIZ-CODE',
            newCode: 'iWMS-PRINT-BIZ-CODE',
            cache: true,
            intermediate: false,
          },
        },
        {
          path: '/dangerousPrint',
          name: 'dangerousPrint',
          component: () => import('./views/outbound/PrintDangerous.vue'),
          meta: {
            code: 'LWMS-PRINT-DANGEROUS-DELIVERY-ORDER',
            newCode: 'iWMS-PRINT-DANGEROUS-DELIVERY-ORDER',
            cache: true,
            intermediate: false,
          }
        },
        // 自绘面单选择
        {
          path: '/cloudPrintReform',
          name: 'cloudPrintReform',
          component: () => import('./views/outbound/cloudPrintReform.vue'),
          meta: {
            code: 'LWMS-PRINTING-TEMPLATE',
            newCode: 'iWMS-PRINTING-TEMPLATE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/manifestPush',
          name: 'manifestPush',
          component: () => import('./views/outbound/ManifestPush.vue'),
          meta: {
            code: 'LWMS-PRINT-MANIFEST-PUSHING',
            newCode: 'iWMS-PRINT-MANIFEST-PUSHING',
            cache: true,
            intermediate: false
          }
        },
        /*盘点单明细*/
        {
          path: '/inventoryDetail',
          name: 'inventoryDetail',
          component: () => import('./views/invop/inventoryDetail.vue'),
          meta: {
            code: '',
            parentPaths: ['/cycleInventory'],
            newCode: '',
            cache: true,
            intermediate: true,
            relatedPageNames: ['cycleInventory']
          }
        },
        /*合规管理*/
        {
          path: '/complianceFileManage',
          name: 'complianceFileManage',
          component: () => import('./views/rulefile/ComplianceFileManage.vue'),
          meta: {
            code: 'LWMS-COMPLIANCE-MANAGE',
            newCode: 'iWMS-COMPLIANCE-MANAGE',
            cache: true,
            intermediate: false,
          }
        },
        /*手工创建移库单*/
        {
          path: '/createTransTask',
          name: 'createTransTask',
          component: () => import('./views/invop/CreateTransTask.vue'),
          meta: {
            code: 'LWMS-CREATE-TRANSFER-TASK-MANUALLY',
            newCode: 'iWMS-CREATE-TRANSFER-TASK-MANUALLY',
            cache: true,
            intermediate: false,
          }
        },
        /*移库任务分配*/
        {
          path: '/assignTransTask',
          name: 'assignTransTask',
          component: () => import('./views/invop/AssignTransTask.vue'),
          meta: {
            code: 'LWMS-TRANSFER-TASK-ALLOCATION',
            newCode: 'iWMS-TRANSFER-TASK-ALLOCATION',
            cache: true,
            intermediate: false,
          }
        },
        /*流程*/
        {
          path: '/processManagement',
          name: 'processManagement',
          component: () => import('./views/master/ProcessManagement.vue'),
          meta: {
            code: 'LWMS-PROCESS-MANAGEMENT',
            newCode: 'iWMS-PROCESS-MANAGEMENT',
            parentPaths: ['/process'],
            relatedPageNames: ['process'],
            cache: true,
            intermediate: false,
          }
        },
        /*流程*/
        {
          path: '/process',
          name: 'process',
          component: () => import('./views/master/Process.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/processManagement'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['processManagement']
          }
        },
        /*货权转移任务分配*/
        {
          path: '/assignOrderChangeTask',
          name: 'assignOrderChangeTask',
          component: () => import('./views/invop/AssignOrderChangeTask.vue'),
          meta: {
            code: 'LWMS-OWNERSHIP-CHANGING-TASK-ALLOCATION',
            newCode: 'iWMS-OWNERSHIP-CHANGING-TASK-ALLOCATION',
            cache: true,
            intermediate: false,
          }
        },
        /*维保任务单列表*/
        {
          path: '/maintenanceTaskList',
          name: 'maintenanceTaskList',
          component: () => import('./views/invop/maintenanceTask/taskOrderList.vue'),
          meta: {
            // parentPaths: ['/maintenanceTaskDetail/:id','/maintenanceTaskResult/:id'],
            code: 'LWMS-RM-TASK-LIST',
            newCode: 'iWMS-RM-TASK-LIST',
            cache: true,
            intermediate: true,
            // relatedPageNames: ['maintenanceTaskDetail','maintenanceTaskResult']
          }
        },
        /*维保任务单详情页列表*/
        {
          path: '/maintenanceTaskDetail/:id',
          name: 'maintenanceTaskDetail',
          component: () => import('./views/invop/maintenanceTask/taskOrderDetail.vue'),
          meta: {
            code: '',
            // parentPaths: ['/maintenanceTaskList'],
            newCode: '',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['maintenanceTaskList']

          }
        },
        /*维保任务单录入页列表*/
        {
          path: '/maintenanceTaskResult/:id',
          name: 'maintenanceTaskResult',
          component: () => import('./views/invop/maintenanceTask/resultEntry.vue'),
          meta: {
            code: '',
            // parentPaths: ['/maintenanceTaskList'],
            newCode: '',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['maintenanceTaskList']
          }
        },
        // 库存锁定
        {
          path: '/stockOpt',
          name: 'stockOpt',
          component: () => import('./views/invop/stockOpt.vue'),
          meta: {
            code: 'LWMS-STOCK-OPT',
            newCode: 'iWMS-STOCK-OPT',
            cache: true,
            intermediate: true,
          }

        },
        /** *在库模块 结束***/
        /** *内配出模块 开始***/
        {
          path: '/innerRecheckScan',
          name: 'innerRecheckScan',
          component: () => import('./views/inner/InnerRecheckScan.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true
          }
        },
        {
          path: '/waveManager',
          name: 'waveManager',
          component: () => import('./views/inner/WaveManager.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true
          }
        },
        {
          path: '/scanGoodsInfo',
          name: 'scanGoodsInfo',
          component: () => import('./views/inner/ScanGoodsInfo.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true
          }
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/inner/Settings.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true
          }
        },
        {
          path: '/shipment',
          name: 'shipment',
          component: () => import('./views/inner/Shipment.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: false,
          }
        },
        /** *内配出模块 结束***/
        /** 出库模块 开始**/
        {
          path: '/customRecheck',
          name: 'customRecheck',
          component: () => import('./views/outbound/CustomRecheck.vue'),
          meta: {
            code: 'LWMS-CHECK-PACKAGE',
            newCode: 'iWMS-CHECK-PACKAGE',
            parentPaths: ['/customRecheckGoods', '/customRecheckExplosive', '/customRecheckMixedGoods', 'customRecheckExplosiveNew'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['customRecheckGoods', 'customRecheckExplosive', 'customRecheckMixedGoods', 'customRecheckExplosiveNew']
          }
        },
        {
          path: '/customRecheckGoods',
          name: 'customRecheckGoods',
          component: () => import('./views/outbound/CustomRecheckGoods.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/customRecheck'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['customRecheck']
          }
        },
        {
          path: '/customRecheckExplosive',
          name: 'customRecheckExplosive',
          component: () => import('./views/outbound/CustomRecheckExplosive.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/customRecheck'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['customRecheck']
          }
        },
        {
          path: '/customRecheckExplosiveNew',
          name: 'customRecheckExplosiveNew',
          component: () => import('./views/outbound/CustomRecheckExplosiveNew.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/customRecheck'],
            cache: false,
            intermediate: true,
            relatedPageNames: ['customRecheck']
          }
        },
        {
          path: '/customRecheckMixedGoods',
          name: 'customRecheckMixedGoods',
          component: () => import('./views/outbound/CustomRecheckMixedGoods.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/customRecheck'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['customRecheck']
          }
        },
        // // 新版复核打包一体化（下线）
        // {
        //   path: '/customRecheckNew',
        //   name: 'customRecheckNew',
        //   component: () => import('./views/outbound/customRecheckNew/customRecheck.vue'),
        //   meta: {
        //     code: 'LWMS-CHECK-PACKAGE-NEW',
        //     newCode: 'iWMS-CHECK-PACKAGE-NEW',
        //     parentPaths: [],
        //     cache: true,
        //     intermediate: true,
        //     relatedPageNames: []
        //   }
        // },
         // 新版打包
         {
          path: '/suPackNew',
          name: 'suPackNew',
          component: () => import('./views/outbound/suPackNew/suPack.vue'),
          meta: {
            code: 'IWMS-SU-PACK-NEW',
            newCode: 'IWMS-SU-PACK-NEW',
            parentPaths: [],
            cache: true,
            intermediate: true,
            relatedPageNames: []
          }
        },
        {
          path: '/guidedPack',
          name: 'guidedPack',
          component: loadGuidedPackComponent,
          meta: {
            code: 'IWMS-GUIDED_PACK',
            newCode: 'IWMS-GUIDED_PACK',
            parentPaths: [],
            cache: true,
            intermediate: true,
            relatedPageNames: []
          }
        },
        // 打包重构（指向 guidedPackRefactor），后端菜单 code 待对齐，暂用占位 IWMS-GUIDED_PACK-REFACTOR
        {
          path: '/guidedPackRefactor',
          name: 'guidedPackRefactor',
          component: () => (['', 'UAT', 'UAT2'].includes(window.APP_ENV)
            ? import('./views/outbound/guidedPackRefactor/guidedPack.vue')
            : import('./views/outbound/guidedPack/guidedPack.vue')),
          meta: {
            code: 'IWMS-GUIDED-PACK-REFACTOR',
            newCode: 'IWMS-GUIDED-PACK-REFACTOR',
            parentPaths: [],
            cache: true,
            intermediate: true,
            relatedPageNames: []
          }
        },
        {
          path: '/vasWorkbench',
          name: 'vasWorkbench',
          component: () => import('./views/outbound/vasWorkbench/vasWorkbench.vue'),
          meta: {
            code: 'IWMS-VAS_WORKBENCH',
            newCode: 'IWMS-VAS_WORKBENCH',
            parentPaths: [],
            cache: true,
            intermediate: true,
            relatedPageNames: []
          }
        },
        {
          path: '/review',
          name: 'review',
          component: () => import('./views/outbound/Review.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true
          }
        },
        //insert by wangzhi 2021-4-6 begin
        {
          path: '/toBRuleReview',
          name: 'toBRuleReview',
          component: () => import('./views/outbound/b2b/ToBRuleReview.vue'),
          meta: {
            code: 'LWMS-2B-RECHECKING',
            newCode: 'iWMS-2B-RECHECKING',
            cache: true,
            intermediate: false,
          }
        },
        //insert by wangzhi 2021-4-9
        {
          path: '/toBSMIntercept',
          name: 'toBSMIntercept',
          component: () => import('./views/outbound/b2b/ToBSMIntercept.vue'),
          meta: {
            code: 'LWMS-2B-SHIPPING-INTERCEPTION',
            newCode: 'iWMS-2B-SHIPPING-INTERCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        //end
        {
          path: '/nonCustomerOrderCheck',
          name: 'nonCustomerOrderCheck',
          component: () => import('./views/outbound/NonCustomerOrderCheck.vue'),
          meta: {
            code: 'LWMS-NON-CUSTOMER-ORDER-CHECK',
            newCode: 'iWMS-NON-CUSTOMER-ORDER-CHECK',
            parentPaths: ['/nonCustomerScanGoods'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['nonCustomerScanGoods']
          }
        },
        {
          path: '/nonCustomerScanPallet',
          name: 'nonCustomerScanPallet',
          component: () => import('./views/outbound/NonCustomerScanPallet.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/nonCustomerOrderCheck'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['nonCustomerOrderCheck']
          }
        },
        {
          path: '/nonCustomerScanGoods',
          name: 'nonCustomerScanGoods',
          component: () => import('./views/outbound/NonCustomerScanGoods.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/nonCustomerScanPallet'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['nonCustomerScanPallet']
          }
        },
        {
          path: '/nonCustomerShipment',
          name: 'nonCustomerShipment',
          component: () => import('./views/outbound/NonCustomerShipment.vue'),
          meta: {
            code: 'LWMS-NON-CUSTOMER-DELIVER-GOODS',
            newCode: 'iWMS-NON-CUSTOMER-DELIVER-GOODS',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/rebinEntry',
          name: 'rebinEntry',
          component: () => import('./views/outbound/rebin/RebinEntry.vue'),
          meta: {
            code: 'LWMS-REBIN-WALL-CHECK',
            newCode: 'iWMS-REBIN-WALL-CHECK',
            parentPaths: ['/rebin'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['rebin']
          }
        },
        {
          path: '/rebin',
          name: 'rebin',
          component: () => import('./views/outbound/rebin/RebinIndex.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/rebinEntry'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['rebinEntry']
          }
        },
        {
          path: '/packEntry',
          name: 'packEntry',
          component: () => import('./views/outbound/pack/PackEntry.vue'),
          meta: {
            code: 'LWMS-INDEPEND-PACKAGE',
            newCode: 'iWMS-INDEPEND-PACKAGE',
            parentPaths: ['/pack'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['pack']
          }
        },
        {
          path: '/pack',
          name: 'pack',
          component: () => import('./views/outbound/pack/Pack.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/packEntry'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['packEntry']
          }
        },
        {
          path: '/storePackage',
          name: 'storePackage',
          component: () => import('./views/outbound/pack/StorePack.vue'),
          meta: {
            code: 'LWMS-STORE-PACK',
            newCode: 'iWMS-STORE-PACK',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/palletPackage',
          name: 'palletPackage',
          component: () => import('./views/outbound/b2b/palletPack.vue'),
          meta: {
            code: 'LWMS-INDEPENDENT-PALLET-PACKAGE',
            newCode: 'iWMS-INDEPENDENT-PALLET-PACKAGE',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/sortingRecheck',
          name: 'sortingRecheck',
          component: () => import('./views/outbound/sortingRecheck/index.vue'),
          meta: {
            code: 'LWMS-SORT-RECHECK-PACK',
            newCode: 'iWMS-SORT-RECHECK-PACK',
            cache: true,
            intermediate: false
          }
        },
        {
          path: '/tmplDebug',
          name: 'tmplDebug',
          component: () => import('./views/print/tmpl-debug/TmplDebug.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true,
          }
        },
        {
          path: '/orderAssignment',
          name: 'orderAssignment',
          component: () => import('./views/outbound/OrderAssignment.vue'),
          meta: {
            code: '',
            newCode: '',
            intermediate: true,
          }
        },
        {
          path: '/replacePackageLabel',
          name: 'replacePackageLabel',
          component: () => import('./views/outbound/ReplacePackageLabel.vue'),
          meta: {
            code: 'LWMS-REPLACE-PACKAGE-LABEL',
            newCode: 'iWMS-REPLACE-PACKAGE-LABEL',
            intermediate: false,
          }
        },
        {
          path: '/storeConfluence',
          name: 'storeConfluence',
          component: () => import('./views/outbound/storeConfluence/StoreConfluence.vue'),
          meta: {
            code: 'LWMS-STORE-CONFLUENCE',
            newCode: 'iWMS-STORE-CONFLUENCE',
            parentPaths: ['/storeConfluence'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['storeConfluence']
          }
        },
        {
          path: '/createMoveTask',
          name: 'CreateMoveTask',
          component: () => import('./views/outbound/moveWms/CreateMoveWmsTask.vue'),
          meta: {
            code: 'LWMS-CREATE-MOVE-TASK',
            newCode: 'iWMS-CREATE-MOVE-TASK',
            cache: true,
            intermediate: false
          }
        },
        {
          path: '/autoWaveGrouping',
          name: 'AutoWaveGrouping',
          component: () => import('./views/outbound/autoWaveGrouping/index.vue'),
          meta: {
            code: 'LWMS-OUTBOUND-AUTO-WAVE',
            newCode: 'iWMS-OUTBOUND-AUTO-WAVE',
            cache: true,
            intermediate: false,
            parentPaths: ['/addCustomization'],
            relatedPageNames: ['AddCustomization']
          }
        },
        {
          path: '/addCustomization',
          name: 'AddCustomization',
          component: () => import('./views/outbound/autoWaveGrouping/components/addCustomization.vue'),
          meta: {
            code: 'LWMS-OUTBOUND-ADD-CUSTOM',
            newCode: 'iWMS-OUTBOUND-ADD-CUSTOM',
            cache: true,
            intermediate: true,
            parentPaths: ['/autoWaveGrouping'],
            relatedPageNames: ['AutoWaveGrouping']
          }
        },
        /** 出库模块 结束**/
        /** base 开始**/
        {
          path: '/logicArea',
          name: 'logicArea',
          component: () => import('./views/base/LogicArea.vue'),
          meta: {
            code: 'LWMS-LOGIC-AREA-MAINTAIN',
            newCode: 'iWMS-LOGIC-AREA-MAINTAIN',
            parentPaths: ['/logicAreaAdd'],
            cache: true,
            intermediate: false,
            relatedPageNames: ['logicAreaAdd']
          }
        },
        {
          path: '/logicAreaAdd',
          name: 'logicAreaAdd',
          component: () => import('./views/base/LogicAreaAddNew.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/logicArea'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['logicArea']
          }
        },
        {
          path: '/priorityJobConfig',
          name: 'priorityJobConfig',
          component: () => import('./views/base/PriorityJobConfig.vue'),
          meta: {
            code: 'LWMS-CONFIG-PRIORITY-JOB',
            newCode: 'iWMS-CONFIG-PRIORITY-JOB',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/releaseOrder',
          name: 'releaseOrder',
          component: () => import('./views/base/ReleaseOrder.vue'),
          meta: {
            code: 'LWMS-RELEASE-ORDER',
            newCode: 'iWMS-RELEASE-ORDER',
            cache: true,
            intermediate: false,
          }
        },
        {
          //  缓存管理页面
          path: '/cache',
          name: 'cache',
          component: () => import('./views/master/Cache.vue'),
          meta: {
            code: 'LWMS-CACHE-MANAGEMENT',
            newCode: 'iWMS-CACHE-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/newGoodsAdd',
          name: 'newGoodsAdd',
          component: () => import('./views/base/NewGoodsAdd.vue'),
          meta: {
            code: 'LWMS-ADD-GOODS',
            newCode: 'iWMS-ADD-GOODS',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/pullGoodsInfo',
          name: 'pullGoodsInfo',
          component: () => import('./views/base/PullGoodsInfo.vue'),
          meta: {
            code: 'LWMS-PULL-GOODS-INFO',
            newCode: 'iWMS-PULL-GOODS-INFO',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/modifyGoodSerial',
          name: 'modifyGoodSerial',
          component: () => import('./views/base/ModifyGoodSerial.vue'),
          meta: {
            code: 'LWMS-MODIFY-GOODS-SERIAL',
            newCode: 'iWMS-MODIFY-GOODS-SERIAL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printConfig',
          name: 'printConfig',
          component: () => import('./views/base/PrintConfig.vue'),
          meta: {
            code: 'LWMS-CONFIG-PRINTER',
            newCode: 'iWMS-CONFIG-PRINTER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/parameterConfig',
          name: 'parameterConfig',
          component: () => import('./views/base/parameterConfig/parameterConfig.vue'),
          meta: {
            code: 'LWMS-PARAMETER-CONFIG',
            newCode: 'iWMS-PARAMETER-CONFIG',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/rfidDeviceManage',
          name: 'rfidDeviceManage',
          component: () => import('./views/base/rfidDeviceManage.vue'),
          meta: {
            code: 'LWMS-RFID-DEVICE-MANAGE',
            newCode: 'iWMS-RFID-DEVICE-MANAGE',
            cache: true,
            intermediate: true, // 临时设置为true跳过权限检查，正式使用时需要在后端配置权限代码后改为false
          }
        },
        /** 异常处理**/
        {
          path: '/workerException',
          name: 'workerException',
          component: () => import('./views/exception/workerException.vue'),
          meta: {
            code: 'LWMS-SYSTEM-WORKER-EXCEPTION',
            newCode: 'iWMS-SYSTEM-WORKER-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/outboundInitException',
          name: 'outboundInitException',
          component: () => import('./views/exception/outbound/initException.vue'),
          meta: {
            code: 'LWMS-BIZ-OUTBOUND-INIT-EXCEPTION',
            newCode: 'iWMS-BIZ-OUTBOUND-INIT-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/inboundInitException',
          name: 'inboundInitException',
          component: () => import('./views/exception/inbound/initException.vue'),
          meta: {
            code: 'LWMS-BIZ-INBOUND-INIT-EXCEPTION',
            newCode: 'iWMS-BIZ-INBOUND-INIT-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/locateException',
          name: 'locateException',
          component: () => import('./views/exception/outbound/locateException.vue'),
          meta: {
            code: 'LWMS-BIZ-LOCATE-EXCEPTION',
            newCode: 'iWMS-BIZ-LOCATE-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/taskAssignException',
          name: 'taskAssignException',
          component: () => import('./views/exception/outbound/taskAssignException.vue'),
          meta: {
            code: 'LWMS-BIZ-TASK-ASSIGN-EXCEPTION',
            newCode: 'iWMS-BIZ-TASK-ASSIGN-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/pullBack',
          name: 'pullBack',
          component: () => import('./views/exception/outbound/pullBack.vue'),
          meta: {
            code: 'LWMS-BIZ-PULL-BACK-ORDER-EXCEPTION',
            newCode: 'iWMS-BIZ-PULL-BACK-ORDER-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/outboundException',
          name: 'outboundException',
          component: () => import('./views/exception/outbound/exception.vue'),
          meta: {
            code: 'LWMS-BIZ-CUSTOMER-ORDER-EXCEPTION',
            newCode: 'iWMS-BIZ-CUSTOMER-ORDER-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/orderCreation',
          name: 'orderCreation',
          component: () => import('./views/outbound/OrderCreation.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/printStorageLocation',
          name: 'printStorageLocation',
          component: () => import('./views/labelPrint/printStorageLocation.vue'),  //labelPrint/printStorageLocation.vue
          meta: {
            code: 'LWMS-PRINT-LOC',
            newCode: 'iWMS-PRINT-LOC',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printContainerNum',
          name: 'printContainerNum',
          component: () => import('./views/labelPrint/printContainerNum.vue'),
          meta: {
            code: 'LWMS-PRINT-CONTAINER',
            newCode: 'iWMS-PRINT-CONTAINER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printGoodsBarCode',
          name: 'printGoodsBarCode',
          component: () => import('./views/labelPrint/printGoodsBarCode.vue'),
          meta: {
            code: 'LWMS-PRINT-GOODS-BARCODE',
            newCode: 'iWMS-PRINT-GOODS-BARCODE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printCartonCode',
          name: 'printCartonCode',
          component: () => import('./views/labelPrint/printCartonCode.vue'),
          meta: {
            code: 'LWMS-PRINT-BOX-CODE',
            newCode: 'iWMS-PRINT-BOX-CODE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printBoxRuleCode',
          name: 'printBoxRuleCode',
          component: () => import('./views/labelPrint/printBoxRuleCode.vue'),
          meta: {
            code: 'LWMS-PRINT-BOX-RULE-CODE',
            newCode: 'iWMS-PRINT-BOX-RULE-CODE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/printCN23',
          name: 'printCN23',
          component: () => import('./views/labelPrint/printCN23.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/printCN23Img',
          name: 'printCN23Img',
          component: () => import('./views/labelPrint/printCN23Img.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/printInvoice',
          name: 'printInvoice',
          component: () => import('./views/labelPrint/printInvoice.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/printInvoiceImg',
          name: 'printInvoiceImg',
          component: () => import('./views/labelPrint/printInvoiceImg.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/printBasicData',
          name: 'printBasicData',
          component: () => import('./views/labelPrint/basicDataPrint.vue'),
          meta: {
            code: 'LWMS-PRINT-BASIC-DATA',
            newCode: 'iWMS-PRINT-BASIC-DATA',
            cache: true,
            intermediate: true
          }
        },
        /***Master模块(开仓) 开始***/
        {
          path: '/createWarehouse',
          name: 'createWarehouse',
          component: () => import('./views/master/CreateWarehouse.vue'),
          meta: {
            code: 'LWMS-CREATE-WARE-HOUSE',
            newCode: 'iWMS-CREATE-WARE-HOUSE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/maintainArea',
          name: 'maintainArea',
          component: () => import('./views/master/MaintainArea.vue'),
          meta: {
            code: 'LWMS-MAINTAIN-AREA',
            newCode: 'iWMS-MAINTAIN-AREA',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/ownerManagement',
          name: 'ownerManagement',
          component: () => import('./views/master/OwnerManagement.vue'),
          meta: {
            code: 'LWMS-OWNER-MANAGEMENT',
            newCode: 'iWMS-OWNER-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/supplier',
          name: 'supplier',
          component: () => import('./views/master/Supplier.vue'),
          meta: {
            code: 'LWMS-SUPPLIER-MANAGER',
            newCode: 'iWMS-SUPPLIER-MANAGER',
            cache: true,
            intermediate: false
          }
        },
        {
          path: '/carrier',
          name: 'carrier',
          component: () => import('./views/master/Carrier.vue'),
          meta: {
            code: 'LWMS-CARRIER-MANAGE',
            newCode: 'iWMS-CARRIER-MANAGE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/carrierProduct',
          name: 'carrierProduct',
          component: () => import('./views/master/CarrierProduct.vue'),
          meta: {
            code: 'LWMS-CARRIER-PRODUCT',
            newCode: 'iWMS-CARRIER-PRODUCT',
            cache: true,
            intermediate: false,
          }
        },
        // {
        //   path: '/SystemDictionary',
        //   name: 'SystemDictionary',
        //   component: () => import('./views/master/SystemDictionary.vue'),
        //   meta: {
        //     cache: true,
        //   }
        // },
        {
          path: '/maintainZone',
          name: 'maintainZone',
          component: () => import('./views/master/MaintainZone.vue'),
          meta: {
            code: 'LWMS-MAINTAIN-ZONE',
            newCode: 'iWMS-MAINTAIN-ZONE',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/maintainIntegratedWorkstation',
          name: 'maintainIntegratedWorkstation',
          component: () => import('./views/master/MaintainIntegratedWorkstation.vue'),
          meta: {
            code: 'LWMS-MAINTAIN-INTEGRATED-WORKSTATION',
            newCode: 'iWMS-MAINTAIN-INTEGRATED-WORKSTATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/addmaintainIntegratedWorkstation',
          name: 'addmaintainIntegratedWorkstation',
          component: () => import('./views/master/addMaintainIntegratedWorkstation.vue'),
          meta: {
            code: 'LWMS-MAINTAIN-INTEGRATED-WORKSTATION',
            newCode: 'iWMS-MAINTAIN-INTEGRATED-WORKSTATION',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/maintainPackingWorkstation',
          name: 'maintainPackingWorkstation',
          component: () => import('./views/master/MaintainPackingWorkstation.vue'),
          meta: {
            code: 'LWMS-MAINTAIN-PACKING-WORKSTATION',
            newCode: 'iWMS-MAINTAIN-PACKING-WORKSTATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receivingDeskManagement',
          name: '/receivingDeskManagement',
          component: () => import('./views/master/ReceivingDeskManagement.vue'),
          meta: {
            code: 'LWMS-RECEIVING-DESK-MANAGEMENT',
            newCode: 'iWMS-RECEIVING-DESK-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/productMaintain',
          name: 'productMaintain',
          component: () => import('./views/master/ProductMaintain.vue'),
          meta: {
            code: 'LWMS-PRODUCT-MAINTAIN',
            newCode: 'iWMS-PRODUCT-MAINTAIN',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/replenishmentRuleConfig',
          name: 'replenishmentRuleConfig',
          component: () => import('./views/master/ReplenishmentRuleConfig.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/productLevelMaintain',
          name: 'productLevelMaintain',
          component: () => import('./views/master/ProductLevelMaintain.vue'),
          meta: {
            code: 'LWMS-PRODUCT-LEVEL-MAINTAIN',
            newCode: 'iWMS-PRODUCT-LEVEL-MAINTAIN',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/goodsAttr',
          name: 'goodsAttr',
          component: () => import('./views/master/goodsAttr.vue'),
          meta: {
            code: 'LWMS-GOODS-ATTR-MANAGEMENT',
            newCode: 'iWMS-GOODS-ATTR-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/cellSpecification',
          name: 'cellSpecification',
          component: () => import('./views/master/CellSpecification.vue'),
          meta: {
            code: 'LWMS-CELL-SPECIFICATION',
            newCode: 'iWMS-CELL-SPECIFICATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/cellMaintain',
          name: 'cellMaintain',
          component: () => import('./views/master/Cell.vue'),
          meta: {
            code: 'LWMS-CELL-MAINTAIN',
            newCode: 'iWMS-CELL-MAINTAIN',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/container',
          name: 'container',
          component: () => import('./views/master/ContainerEntry.vue'),
          meta: {
            code: 'LWMS-CONTAINER',
            newCode: 'iWMS-CONTAINER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/systemParameter',
          name: 'systemParameter',
          component: () => import('./views/master/SystemParameter.vue'),
          meta: {
            code: 'LWMS-SYSTEM-PARAMETER',
            newCode: 'iWMS-SYSTEM-PARAMETER',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/pickingOrder',
          name: 'pickingOrder',
          component: () => import('./views/master/AislelPickupSeq.vue'),
          meta: {
            code: 'LWMS-PICKING-SEQUENCE-MANAGEMENT',
            newCode: 'iWMS-PICKING-SEQUENCE-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/systemDictionary',
          name: 'systemDictionary',
          component: () => import('./views/master/SystemDictionary.vue'),
          meta: {
            code: 'LWMS-SYSTEM-DICTIONARY',
            newCode: 'iWMS-SYSTEM-DICTIONARY',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/userWarehouseRelMaintain',
          name: 'userWarehouseRelMaintain',
          component: () => import('./views/master/UserWarehouseRelMaintain.vue'),
          meta: {
            code: 'LWMS-USER-WAREHOUSE-RELMAINTAIN',
            newCode: 'iWMS-USER-WAREHOUSE-RELMAINTAIN',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/selectWarehouse',
          name: 'selectWarehouse',
          component: () => import('./views/master/SelectWarehouse.vue'),
          meta: {
            code: 'LWMS-USER-WAREHOUSE-SELECT',
            newCode: 'iWMS-USER-WAREHOUSE-SELECT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/abnormalCenterInbound',
          name: 'abnormalCenterInbound',
          component: () => import('./views/exception/abnormalCenter/inbound.vue'),
          meta: {
            code: 'LWMS-ABNORMAL-CENTER-INBOUND',
            newCode: 'iWMS-ABNORMAL-CENTER-INBOUND',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/abnormalCenterOutbound',
          name: 'abnormalCenterOutbound',
          component: () => import('./views/exception/abnormalCenter/outbound.vue'),
          meta: {
            code: 'LWMS-ABNORMAL-CENTER-OUTBOUND',
            newCode: 'iWMS-ABNORMAL-CENTER-OUTBOUND',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/settingWarehouseInfo',
          name: 'SettingWarehouseInfo',
          component: () => import('./views/master/SettingWarehouseInfo.vue'),
          meta: {
            code: 'LWMS-WAREHOUSE-INFO-CONFIGURATION',
            newCode: 'iWMS-WAREHOUSE-INFO-CONFIGURATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/serialRule',
          name: 'SerialRule',
          component: () => import('./views/master/SerialRule.vue'),
          meta: {
            code: 'LWMS-SERIAL-RULE-QUERY',
            newCode: 'iWMS-SERIAL-RULE-QUERY',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/cloudPrintTemplateConfig',
          name: 'cloudPrintTemplateConfig',
          component: () => import('./views/master/CloudPrintTemplateConfig.vue'),
          meta: {
            code: '',
            cache: false,
            intermediate: true
          }
        },
        {
          path: '/unauthorized',
          name: 'unauthorized',
          component: () => import('./views/Unauthorized.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: false,
            intermediate: true
          }
        }, {
          path: '/capacityConfig',
          name: 'capacityConfig',
          component: () => import('./views/container/CapacityConfig.vue'),
          meta: {
            code: 'LWMS-BOOKING-META-CONFIGURATION',
            newCode: 'iWMS-BOOKING-META-CONFIGURATION',
            cache: false,
            intermediate: false,
          }
        }, {
          path: '/appointmentConfig',
          name: 'appointmentConfig',
          component: () => import('./views/appointment/AppointmentConfig.vue'),
          meta: {
            code: 'LWMS-BOOKING-CONFIG',
            newCode: 'iWMS-BOOKING-CONFIG',
            cache: false,
            intermediate: false,
          }
        }, {
          path: '/parcelHandover',
          name: 'parcelHandover',
          component: () => import('./views/outbound/parcelHandover/ParcelHandover.vue'),
          meta: {
            code: 'LWMS-PARCEL-HANDOVER',
            newCode: 'iWMS-PARCEL-HANDOVER',
            cache: true,
            intermediate: false,
          },
        }, {
            path: '/containerHandover',
            name: 'containerHandover',
            component: () => import('./views/outbound/parcelHandover/containerHandover.vue'),
            meta: {
              code: 'LWMS-CONTAINER-HANDOVER',
              newCode: 'iWMS-CONTAINERL-HANDOVER',
              cache: true,
              intermediate: false,
            },
        }, {
          // 批量交接
          path: '/parcelBatchHandover',
          name: 'parcelBatchHandover',
          component: () => import('./views/outbound/parcelHandover/parcelBatchHandover.vue'),
          meta: {
            code: 'LWMS-PARCEL-BATCH-HANDOVER',
            newCode: 'iWMS-PARCEL-BATCH-HANDOVER',
            cache: true,
            intermediate: false,
          }
        },
        // // 容器批量交接
        // {
        //   path: '/containerBatchHandover',
        //   name: 'containerHandover',
        //   component: () => import('./views/outbound/parcelHandover/containerBatchHandover.vue'),
        //   meta: {
        //     code: 'LWMS-CONTAINER-BATCH-HANDOVER',
        //     newCode: 'iWMS-CONTAINERL-BATCH-HANDOVER',
        //     cache: true,
        //     intermediate: false,
        //   },
        // },
        {
          // 称重量方
          path: '/parcelWeighingSquare',
          name: 'parcelWeighingSquare',
          component: () => import('./views/outbound/parcelWeighingSquare.vue'),
          meta: {
            code: 'LWMS-PARCEL-MEASUREMENT',
            newCode: 'iWMS-PARCEL-MEASUREMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          //  月台管理页面
          path: '/dock',
          name: 'dock',
          component: () => import('./views/master/dock.vue'),
          meta: {
            code: 'LWMS-DOCK-MANAGEMENT',
            newCode: 'iWMS-DOCK-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/personalizedWorkGroup',
          name: 'personalizedWorkGroup',
          component: () => import('./views/master/PersonalizedWorkGroup.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/taskAssignment'],
            cache: true,
            intermediate: true,
            relatedPageNames: ['taskAssignment']
          }
        },
        {
          path: '/consumableitem',
          name: 'consumableitem',
          component: () => import('./views/master/Consumableitem.vue'),
          meta: {
            code: 'LWMS-CONSUMABLE-MANAGEMENT',
            newCode: 'iWMS-CONSUMABLE-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        // {
        //   path: '/dictionaryDetails',
        //   name: 'dictionaryDetails',
        //   component: () => import('./views/master/DictionaryDetails.vue'),
        //   meta: {
        //     cache: true,
        //   }
        // }
        /***Master模块(开仓) 结束***/
        /*** Vas订单创建 ***/
        {
          path: '/vasOrderAdd',
          name: 'vasOrderAdd',
          component: () => import('./views/vas/VasOrderAdd.vue'),
          meta: {
            code: 'LWMS-VAS-ADD',
            newCode: 'iWMS-VAS-ADD',
            cache: true,
            intermediate: true
          }
        },
        /*** 申请单查询列表 **/
        {
          path: '/applyOrderList',
          name: 'applyOrderList',
          component: () => import('./views/invop/ApplyOrderList.vue'),
          meta: {
            code: 'LWMS-APPLY-ORDER', // TODO 权限系统注册后填 LWMS-xxx
            newCode: 'iWMS-APPLY-ORDER', // TODO iWMS-xxx
            cache: true,
            intermediate: true
          }
        },
        /*** 新建备件库申请单 **/
        {
          path: '/sparePartsApplyCreate',
          name: 'sparePartsApplyCreate',
          component: () => import('./views/invop/SparePartsApplyCreate.vue'),
          meta: {
            code: 'LWMS-APPLY-CREATE', // TODO 权限系统注册后填 LWMS-xxx
            newCode: 'iWMS-APPLY-CREATE', // TODO iWMS-xxx
            cache: true,
            intermediate: true
          }
        },
        /*** Vas订单列表 **/
        {
          path: '/vasOrderList',
          name: 'vasOrderList',
          component: () => import('./views/vas/VasOrderList.vue'),
          meta: {
            code: 'LWMS-VAS-QUERY',
            newCode: 'iWMS-VAS-QUERY',
            parentPaths: ['/vasOrderCheck'],
            relatedPageNames: ['vasOrderCheck'],
            cache: true,
            intermediate: false
          }
        },
        {
          path: '/vasOrderCheck',
          name: 'vasOrderCheck',
          component: () => import('./views/vas/VasOrderCheck.vue'),
          meta: {
            code: '',
            newCode: '',
            parentPaths: ['/vasOrderList'],
            relatedPageNames: ['vasOrderList'],
            cache: true,
            intermediate: true
          }
        },
        /*** Vas订单任务分配 **/
        {
          path: '/vasOrderAssignList',
          name: 'vasOrderAssignList',
          component: () => import('./views/vas/VasOrderAssignList.vue'),
          meta: {
            code: 'LWMS-VAS-ALLOCATION',
            newCode: 'iWMS-VAS-ALLOCATION',
            cache: true,
            intermediate: false,
          }
        },
        /*** Vas订单定位异常 **/
        {
          path: '/vasOrderLocateException',
          name: 'vasOrderLocateException',
          component: () => import('./views/vas/VasOrderLocateException.vue'),
          meta: {
            code: 'LWMS-VAS-LOCATE-EXCEPTION',
            newCode: 'iWMS-VAS-LOCATE-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/modifyPrintBasicData',
          name: 'modifyPrintBasicData',
          component: () => import('./views/outbound/hideMaintain/ModifyPrintBasicData.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        // 辅助分析-单品订单分析
        {
          path: '/singleOrder',
          name: 'singleOrder',
          component: () => import('./views/outbound/singleOrder.vue'),
          meta: {
            code: 'LWMS-HOT-SALE-ANALYSIS',
            newCode: 'iWMS-HOT-SALE-ANALYSIS',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/poLabelPrinting',
          name: 'poLabelPrinting',
          component: () => import('./views/outbound/poLabelPrinting.vue'),
          meta: {
            code: 'LWMS-PRINT-PO-LABEL',
            newCode: 'iWMS-PRINT-PO-LABEL',
            cache: true,
            intermediate: false
          }
        },
        {
          path: '/checkboxs',
          name: 'checkboxs',
          component: () => import('./views/outbound/checkboxs.vue'),
          meta: {
            code: 'LWMS-CHECKBOXS',
            newCode: 'LWMS-CHECKBOXS',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/poCheck',
          name: 'poCheck',
          component: () => import('./views/outbound/poCheck.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/warehouseCapacity',
          name: 'warehouseCapacity',
          component: () => import('./views/master/warehouseCapacity.vue'),
          meta: {
            code: 'LWMS-WAREHOUSE-CAPACITY',
            newCode: 'iWMS-WAREHOUSE-CAPACITY',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/reservationList',
          name: 'reservationList',
          component: () => import('./views/inbound/reservation/ReservationList.vue'),
          meta: {
            code: 'LWMS-RESERVATION-LIST',
            newCode: 'iWMS-RESERVATION-LIST',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/reservationCreate',
          name: 'reservationCreate',
          component: () => import('./views/inbound/reservation/CreateReservation.vue'),
          meta: {
            code: 'LWMS-RESERVATION-CREATE',
            newCode: 'iWMS-RESERVATION-CREATE',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/reservationManage',
          name: 'reservationManage',
          component: () => import('./views/inbound/reservation/QuotaManagement.vue'),
          meta: {
            code: 'LWMS-RESERVATION-MANAGE',
            newCode: 'iWMS-RESERVATION-MANAGE',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/reservationConfig',
          name: 'reservationConfig',
          component: () => import('./views/inbound/reservation/ReservationSystem.vue'),
          meta: {
            code: 'LWMS-RESERVATION-CONFIG',
            newCode: 'iWMS-RESERVATION-CONFIG',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/reservationReport',
          name: 'reservationReport',
          component: () => import('./views/inbound/reservation/QuotaUsageReport.vue'),
          meta: {
            code: 'LWMS-RESERVATION-REPORT',
            newCode: 'iWMS-RESERVATION-REPORT',
            cache: true,
            intermediate: true
          }
        },
        {
          path: '/queryOrderGoodsInfo',
          name: 'queryOrderGoodsInfo',
          component: () => import('./views/outbound/tool/queryOrderGoodsInfo.vue'),
          meta: {
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/packTaskForm',
          name: 'packTaskForm',
          component: () => import('./views/management/packSu/taskForm.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PACK-TASK',
            newCode: 'iWMS-MANAGEMENT-PACK-TASK',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/packDetailsSubpage',
          name: 'packDetailsSubpage',
          component: () => import('./views/management/packSu/detailsSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PACK-DETAIL',
            newCode: 'iWMS-MANAGEMENT-PACK-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/packWorkDetails',
          name: 'packWorkDetails',
          component: () => import('./views/management/packSu/workDetails.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PACK-WORK-DETAILS',
            newCode: 'iWMS-MANAGEMENT-PACK-WORK-DETAILS',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/packException',
          name: 'packException',
          component: () => import('./views/management/packSu/packExceptionWrap.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PACK-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-PACK-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/vasTask',
          name: 'vasTask',
          component: () => import('./views/management/vasSu/vasTask.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-VAS-TASK',
            newCode: 'iWMS-MANAGEMENT-VAS-TASK',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/vasActionDetail',
          name: 'vasActionDetail',
          component: () => import('./views/management/vasSu/vasActionDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-VAS-ACTION-DETAIL',
            newCode: 'iWMS-MANAGEMENT-VAS-ACTION-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/vasException',
          name: 'vasException',
          component: () => import('./views/management/vasSu/vasException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-VAS-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-VAS-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/vasDetailsSubpage',
          name: 'vasDetailsSubpage',
          component: () => import('./views/management/vasSu/vasDetailsSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-VAS-DETAIL',
            newCode: 'iWMS-MANAGEMENT-VAS-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/containerSearch',
          name: 'containerSearch',
          component: () => import('./views/management/containerSu/containerSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-CONTAINER-SEARCH',
            newCode: 'iWMS-MANAGEMENT-CONTAINER-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/containerDetailsSubpage',
          name: 'containerDetailsSubpage',
          component: () => import('./views/management/containerSu/containerDetailsSubpage.vue'),
          meta: {
            code: '',
            newCode: 'iWMS-MANAGEMENT-CONTAINER-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/containerDetail',
          name: 'containerDetail',
          component: () => import('./views/management/containerSu/containerDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-CONTAINER-DETAIL',
            newCode: 'iWMS-MANAGEMENT-CONTAINER-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/containerException',
          name: 'containerException',
          component: () => import('./views/management/containerSu/containerException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-CONTAINER-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-CONTAINER-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/rebinDetail',
          name: 'rebinDetail',
          component: () => import('./views/management/rebinSu/rebinDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-REBIN-DETAIL',
            newCode: 'iWMS-MANAGEMENT-REBIN-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/rebinSearch',
          name: 'rebinSearch',
          component: () => import('./views/management/rebinSu/rebinSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-REBIN-SEARCH',
            newCode: 'iWMS-MANAGEMENT-REBIN-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/rebinException',
          name: 'rebinException',
          component: () => import('./views/management/rebinSu/rebinException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-REBIN-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-REBIN-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/rebinDetailsSubpage',
          name: 'rebinDetailsSubpage',
          component: () => import('./views/management/rebinSu/rebinDetailsSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-REBIN-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-REBIN-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/pickingSearch',
          name: 'pickingSearch',
          component: () => import('./views/management/pickingSu/pickingSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PICKING-SEARCH',
            newCode: 'iWMS-MANAGEMENT-PICKING-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/pickingDetail',
          name: 'pickingDetail',
          component: () => import('./views/management/pickingSu/pickingDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PICKING-DETAIL',
            newCode: 'iWMS-MANAGEMENT-PICKING-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/pickingDetailsSubpage',
          name: 'pickingDetailsSubpage',
          component: () => import('./views/management/pickingSu/pickingDetailsSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PICKING-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-PICKING-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/pickingException',
          name: 'pickingException',
          component: () => import('./views/management/pickingSu/pickingException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-PICKING-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-PICKING-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/sortingSearch',
          name: 'sortingSearch',
          component: () => import('./views/management/sortingSu/sortingSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SORTING-SEARCH',
            newCode: 'iWMS-MANAGEMENT-SORTING-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/sortingException',
          name: 'sortingException',
          component: () => import('./views/management/sortingSu/sortingException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SORTING-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-SORTING-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/sortingDetailsSubpage',
          name: 'sortingDetailsSubpage',
          component: () => import('./views/management/sortingSu/sortingDetailsSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SORTING-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-SORTING-DETAIL-SUBPAGE',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/sortingDetail',
          name: 'sortingDetail',
          component: () => import('./views/management/sortingSu/sortingDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SORTING-DETAIL',
            newCode: 'iWMS-MANAGEMENT-SORTING-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/unloadingTask',
          name: 'flUnloadTask',
          component: () => import('./views/management/firstLegUnloadSu/flUnloadTask.vue'),
          // name: 'unloadingTask',
          // component: () => import('./views/firstLeg/unloading/unloadingTask.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_unloading_task',
            cache: true,
            intermediate: false,
            // relatedPageNames: ['flUnloadTaskSubpage'],
            // parentPaths: ['/flUnloadTaskSubpage'],
          }
        },
        {          
          path: '/pickupGrouping',
          name: 'pickupGrouping',
          component: () => import('./views/base/pickupGrouping.vue'),
          meta: {
            newCode: 'iWMS-PICKUP-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/unloadingDetail',
          name: 'flUnloadDetail',
          component: () => import('./views/management/firstLegUnloadSu/flUnloadDetail.vue'),
          // name: 'unloadingDetail',
          // component: () => import('./views/firstLeg/unloading/unloadingDetail.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_unloading_order',
            cache: true,
            intermediate: false,
            // relatedPageNames: ['flUnloadTaskSubpage'],
            // parentPaths: ['/flUnloadTaskSubpage'],
          }
        },
        {
          path: '/flUnloadException',
          name: 'flUnloadException',
          component: () => import('./views/management/firstLegUnloadSu/flUnloadException.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_unloading_carton',
            cache: true,
            intermediate: false,
            // relatedPageNames: ['flUnloadTaskSubpage'],
            // parentPaths: ['/flUnloadTaskSubpage'],
          }
        },
        {
          path: '/addOrEditPickup',
          name: 'addOrEditPickup',
          component: () => import('./views/base/addOrEditPickup.vue'),
          meta: {
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/receivingTask',
          name: 'flReceiveTask',
          component: () => import('./views/management/firstLegReceiveSu/flReceiveTask.vue'),
          // name: 'receivingTask',
          // component: () => import('./views/firstLeg/receiving/receivingTask.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_receiving_order',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receivingDetail',
          name: 'flReceiveDetail',
          component: () => import('./views/management/firstLegReceiveSu/flReceiveDetail.vue'),
          // name: 'receivingDetail',
          // component: () => import('./views/firstLeg/receiving/receivingDetail.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_receiving_order_detail',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flReceiveException',
          name: 'flReceiveException',
          component: () => import('./views/management/firstLegReceiveSu/flReceiveException.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_receiving_order_short',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/checkDetail',
          name: 'flCheckDetail',
          component: () => import('./views/management/firstLegCheckSu/flCheckDetail.vue'),
          // name: 'checkDetail',
          // component: () => import('./views/firstLeg/check/checkDetail.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_check_detail',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/checkTask',
          name: 'flCheckTask',
          component: () => import('./views/management/firstLegCheckSu/flCheckTask.vue'),
          // name: 'checkTask',
          // component: () => import('./views/firstLeg/check/checkTask.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_check_order',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flCheckException',
          name: 'flCheckException',
          component: () => import('./views/management/firstLegCheckSu/flCheckException.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_check_exception',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/sendDetail',
          name: 'flShipDetail',
          component: () => import('./views/management/firstLegShipSu/flShipDetail.vue'),
          // name: 'sendDetail',
          // component: () => import('./views/firstLeg/send/sendDetail.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_send_detail',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flShipException',
          name: 'flShipException',
          component: () => import('./views/management/firstLegShipSu/flShipException.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_send_exception',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/sendTask',
          name: 'flShipTask',
          component: () => import('./views/management/firstLegShipSu/flShipTask.vue'),
          // name: 'sendTask',
          // component: () => import('./views/firstLeg/send/sendTask.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_send_worker',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/workAreaMgmt',
          name: 'workAreaMgmt',
          component: () => import('./views/master/workAreaMgmt.vue'),
          meta: {
            newCode: 'iWMS-BASE-WORK-AREA-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/minion',
          name: 'minion',
          component: () => import('./views/inbound/Minion.vue'),
          meta: {
            newCode: '',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/shelfSearch',
          name: 'shelfSearch',
          component: () => import('./views/management/shelfSu/shelfSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SHELF-SEARCH',
            newCode: 'iWMS-MANAGEMENT-SHELF-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/shelfDetail',
          name: 'shelfDetail',
          component: () => import('./views/management/shelfSu/shelfDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SHELF-DETAIL',
            newCode: 'iWMS-MANAGEMENT-SHELF-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/shelfException',
          name: 'shelfException',
          component: () => import('./views/management/shelfSu/shelfException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SHELF-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-SHELF-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/shelfDetailSubpage',
          name: 'shelfDetailSubpage',
          component: () => import('./views/management/shelfSu/shelfDetailSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-SHELF-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-SHELF-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/unshelfSearch',
          name: 'unshelfSearch',
          component: () => import('./views/management/unshelfSu/unshelfSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-UNSHELF-SEARCH',
            newCode: 'iWMS-MANAGEMENT-UNSHELF-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/unshelfDetail',
          name: 'unshelfDetail',
          component: () => import('./views/management/unshelfSu/unshelfDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-UNSHELF-DETAIL',
            newCode: 'iWMS-MANAGEMENT-UNSHELF-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/unshelfException',
          name: 'unshelfException',
          component: () => import('./views/management/unshelfSu/unshelfException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-UNSHELF-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-UNSHELF-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/unshelfDetailSubpage',
          name: 'unshelfDetailSubpage',
          component: () => import('./views/management/unshelfSu/unshelfDetailSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-UNSHELF-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-UNSHELF-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/addUnshelfTask',
          name: 'addUnshelfTask',
          component: () => import('./views/management/unshelfSu/addUnshelfTask.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-UNSHELF-ADD',
            newCode: 'iWMS-MANAGEMENT-UNSHELF-ADD',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/stockSearch',
          name: 'stockSearch',
          component: () => import('./views/management/stockSu/stockSearch.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-STOCK-SEARCH',
            newCode: 'iWMS-MANAGEMENT-STOCK-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/stockDetail',
          name: 'stockDetail',
          component: () => import('./views/management/stockSu/stockDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-STOCK-DETAIL',
            newCode: 'iWMS-MANAGEMENT-STOCK-DETAIL',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/stockException',
          name: 'stockException',
          component: () => import('./views/management/stockSu/stockException.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-STOCK-EXCEPTION',
            newCode: 'iWMS-MANAGEMENT-STOCK-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/stockDetailSubpage',
          name: 'stockDetailSubpage',
          component: () => import('./views/management/stockSu/stockDetailSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-STOCK-DETAIL-SUBPAGE',
            newCode: 'iWMS-MANAGEMENT-STOCK-DETAIL-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/containerMgmt',
          name: 'containerMgmt',
          component: () => import('./views/master/ContainerMgmt/index.vue'),
          meta: {
            newCode: 'iWMS-CONTAINER-NEW',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/addContainer',
          name: 'addContainer',
          component: () => import('./views/master/ContainerMgmt/addContainer.vue'),
          meta: {
            newCode: 'iWMS-CONTAINER-ADD',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/containerSpecMgmt',
          name: 'containerSpecMgmt',
          component: () => import('./views/master/ContainerSpecMgmt/index.vue'),
          meta: {
            newCode: 'iWMS-CONTAINER-SPECIFICATION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/addContainerSpec',
          name: 'addContainerSpec',
          component: () => import('./views/master/ContainerSpecMgmt/addContainerSpec.vue'),
          meta: {
            newCode: 'iWMS-CONTAINERSPEC-ADD',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['containerSpecMgmt'],
            // parentPaths: ['/containerSpecMgmt'],
          }
        },
        {
          path: '/rebinWallMgmt',
          name: 'rebinWallMgmt',
          component: () => import('./views/master/rebinWallMgmt/index.vue'),
          meta: {
            newCode: 'iWMS-REBINWALL-MANAGEMENT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/addRebinWall',
          name: 'addRebinWall',
          component: () => import('./views/master/rebinWallMgmt/addRebinWall.vue'),
          meta: {
            newCode: 'iWMS-REBINWALL-ADD',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['rebinWallMgmt'],
            // parentPaths: ['/rebinWallMgmt'],
          }
        },
        {
          path: '/rebinWallDetail',
          name: 'rebinWallDetail',
          component: () => import('./views/master/rebinWallMgmt/rebinWallDetail.vue'),
          meta: {
            newCode: 'iWMS-REBINWALL-DETAIL',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['rebinWallMgmt'],
            // parentPaths: ['/rebinWallMgmt'],
          }
        },
        {
          path: '/unloadTask',
          name: 'unloadTask',
          component: () => import('./views/management/unloadSu/unloadTask.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-UNLOAD-SEARCH',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/unloadDetail',
          name: 'unloadDetail',
          component: () => import('./views/management/unloadSu/unloadDetail.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-UNLOAD-DETAIL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/unloadException',
          name: 'unloadException',
          component: () => import('./views/management/unloadSu/unloadException.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-UNLOAD-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receiveTask',
          name: 'receiveTask',
          component: () => import('./views/management/receiveSu/receiveTask.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-RECEIVE-SEARCH',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receiveDetail',
          name: 'receiveDetail',
          component: () => import('./views/management/receiveSu/receiveDetail.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-RECEIVE-DETAIL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/receiveException',
          name: 'receiveException',
          component: () => import('./views/management/receiveSu/receiveException.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-RECEIVE-EXCEPTION',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/putAwayTask',
          name: 'putAwayTask',
          component: () => import('./views/management/putAwaySu/putAwayTask.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-PUTAWAY-SEARCH',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/putAwayDetail',
          name: 'putAwayDetail',
          component: () => import('./views/management/putAwaySu/putAwayDetail.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-PUTAWAY-DETAIL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/putAwayException',
          name: 'putAwayException',
          component: () => import('./views/management/putAwaySu/putAwayException.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-PUTAWAY-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/inboundCheckTask',
          name: 'inboundCheckTask',
          component: () => import('./views/management/checkSu/inboundCheckTask.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-CHECK-SEARCH',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flShelfTask',
          name: 'flShelfTask',
          component: () => import('./views/management/firstLegShelfSu/flShelfTask.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_shelf_worker',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/inboundCheckDetail',
          name: 'inboundCheckDetail',
          component: () => import('./views/management/checkSu/inboundCheckDetail.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-CHECK-DETAIL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flShelfDetail',
          name: 'flShelfDetail',
          component: () => import('./views/management/firstLegShelfSu/flShelfDetail.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_shelf_detail',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/inboundCheckException',
          name: 'inboundCheckException',
          component: () => import('./views/management/checkSu/inboundCheckException.vue'),
          meta: {
            newCode: 'iWMS-MANAGEMENT-CHECK-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flShelfException',
          name: 'flShelfException',
          component: () => import('./views/management/firstLegShelfSu/flShelfException.vue'),
          meta: {
            newCode: 'iWMS-FIRST-wms_tc_shelf_exception',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flInventoryQuery',
          name: 'flInventoryQuery',
          component: () => import('./views/management/firstLegInventory/flInventoryQuery.vue'),
          meta: {
            newCode: 'iWMS-FIRST-inventory-query',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/permissionMgmt',
          name: 'PermissionMgmt',
          component: () => import('./views/master/PermissionMgmt.vue'),
          meta: {
            newCode: 'iWMS-PERMISSION-MGMT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/flShipTaskSubpage',
          name: 'flShipTaskSubpage',
          component: () => import('./views/management/firstLegShipSu/flShipTaskSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/flCheckTaskSubpage',
          name: 'flCheckTaskSubpage',
          component: () => import('./views/management/firstLegCheckSu/flCheckTaskSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_check_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_check_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/flReceiveSubpage',
          name: 'flReceiveSubpage',
          component: () => import('./views/management/firstLegReceiveSu/flReceiveSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/flShelfTaskSubpage',
          name: 'flShelfTaskSubpage',
          component: () => import('./views/management/firstLegShelfSu/flShelfTaskSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_shelf_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_shelf_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/flUnloadTaskSubpage',
          name: 'flUnloadTaskSubpage',
          component: () => import('./views/management/firstLegUnloadSu/flUnloadTaskSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_unloading_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_unloading_subpage',
            cache: false,
            intermediate: true,
            // relatedPageNames: ['flUnloadTask', 'flUnloadDetail', 'flUnloadException'],
            // parentPaths: ['/unloadingTask'  ,'/unloadingDetail','/flUnloadException'],
          }
        },
        {
          path: '/flReceipt',
          name: 'flReceipt',
          component: () => import('./views/management/flReceiptInquiry/flReceipt.vue'),
          meta: {
            code: 'iWMS-FUNCTION-IB-flReceipt',
            newCode: 'iWMS-FUNCTION-IB-flReceipt',
            cache: true,
            intermediate: true,
            relatedPageNames: ['flReceiveProgress','flCheckProgress'],
            parentPaths: ['/flReceiveProgress','/flCheckProgress'],
          }
        },
        {
          path: '/flReceiveProgress',
          name: 'flReceiveProgress',
          component: () => import('./views/management/flReceiptInquiry/flReceiveProgress.vue'),
          meta: {
            code: 'iWMS-FUNCTION-IB-flReceiveProgress',
            newCode: 'iWMS-FUNCTION-IB-flReceiveProgress',
            cache: true,
            intermediate: true,
            // relatedPageNames: ['flReceipt'],
            // parentPaths: ['/flReceipt'],
          }
        },
        {
          path: '/flCheckProgress',
          name: 'flCheckProgress',
          component: () => import('./views/management/flReceiptInquiry/flCheckProgress.vue'),
          meta: {
            code: 'iWMS-FUNCTION-IB-flCheckProgress',
            newCode: 'iWMS-FUNCTION-IB-flCheckProgress',
            cache: true,
            intermediate: true,
            // relatedPageNames: ['flReceipt'],
            // parentPaths: ['/flReceipt'],
          }
        },
        {
          path: '/terminalMgmt',
          name: 'TerminalMgmt',
          component: () => import('./views/master/TerminalMgmt.vue'),
          meta: {
            newCode: 'iWMS-TERMINAL-MGMT',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/anomalyMgmt',
          name: 'anomalyMgmt',
          component: () => import('./views/invop/anomalyOnline/anomalyMgmt.vue'),
          meta: {
            code: 'iWMS-ANOMALY-TASK-MANAGEMENT',
            newCode: 'iWMS-ANOMALY-TASK-MANAGEMENT',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/anomalySubpage',
          name: 'anomalySubpage',
          component: () => import('./views/invop/anomalyOnline/anomalySubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_unloading_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_unloading_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/assistantsMgt',
          name: 'assistantsMgt',
          component: () => import('./views/management/assistantsMgt/report.vue'),
          meta: {
            code: 'iWMS-ASSISTANT-MANAGEMENT',
            newCode: 'iWMS-ASSISTANT-MANAGEMENT',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/proxyTest',
          name: 'proxyTest',
          component: () => import('./views/proxyTest.vue'),
          meta: {
            code: 'iWMS-PROXY-TEST',
            newCode: 'iWMS-PROXY-TEST',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/inboundCheckSubpage',
          name: 'inboundCheckSubpage',
          component: () => import('./views/management/checkSu/inboundCheckSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/inboundReceiveSubpage',
          name: 'inboundReceiveSubpage',
          component: () => import('./views/management/receiveSu/inboundReceiveSubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/inboundPutawaySubpage',
          name: 'inboundPutawaySubpage',
          component: () => import('./views/management/putAwaySu/inboundPutawaySubpage.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            newCode: 'iWMS-MANAGEMENT-wms_tc_receiving_subpage',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/containerTransferTask',
          name: 'containerTransferTask',
          component: () => import('./views/management/containerTransferSu/containerTransferTask.vue'),
          meta: {
            newCode: 'iWMS-CONTAINERTRANSFER-SEARCH',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/containerTransferDetail',
          name: 'containerTransferDetail',
          component: () => import('./views/management/containerTransferSu/containerTransferDetail.vue'),
          meta: {
            newCode: 'iWMS-CONTAINERTRANSFER-DETAIL',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/containerTransferException',
          name: 'containerTransferException',
          component: () => import('./views/management/containerTransferSu/containerTransferException.vue'),
          meta: {
            newCode: 'iWMS-CONTAINERTRANSFER-EXCEPTION',
            cache: true,
            intermediate: false,
          }
        },
        {
          path: '/containerTransferSubpage',
          name: 'containerTransferSubpage',
          component: () => import('./views/management/containerTransferSu/containerTransferSubpage.vue'),
          meta: {
            newCode: 'iWMS-CONTAINERTRANSFER-SUBPAGE',
            cache: false,
            intermediate: true,
          }
        },
        {
          path: '/anomalyDetail',
          name: 'anomalyDetail',
          component: () => import('./views/invop/anomalyOnline/anomalyDetail.vue'),
          meta: {
            code: 'iWMS-MANAGEMENT-anomalyDetail',
            newCode: 'iWMS-MANAGEMENT-anomalyDetail',
            cache: true,
            intermediate: true,
          }
        },
        {
          path: '/pages-outbound/:functionId',
          name: 'pagesOutbound',
          component: () => import('./views/micro/pagesOutbound.vue'),
          meta: {
            code: '',
            newCode: '',
            cache: true,
            intermediate: true,
          }
        },
      ]
    }

  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


// 路由之前
router.beforeEach((to, from, next) => {
  const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
  const userName =  Cookies.get('userName')
  if(warehouseNo && userName) {
    localStorage.setItem(`lastInvokeTime_${warehouseNo}_${userName}`, Date.now())
  }
  let ignoredRouterNames = ['unauthorized', 'selectWarehouse', 'userWarehouseRelMaintain']
  if (_.includes(ignoredRouterNames, to.name)) {
    next()
    return
  }
  if (['suPackNew', 'guidedPack', 'vasWorkbench'].includes(to.name)) {
    // const isCollapse = store.state.mutations.isCollapse;
    store.commit('setCollapse', true)
    // if (!isCollapse) {
    //   // store.dispatch('toggleCollapse');
    //   this.$store.commit('setCollapse', true)
    // }
  }
  let errorContent = '1400037'
  let request_url = ''
  // intermediate 判断是否是中间页面，中间页面传true，不校验权限
  // 新版本增加root=iWMS的参数
  if (isNewVersion === '1') {
    let newCode = to?.meta?.newCode;
    let intermediate = to?.meta?.intermediate;
    // 如果没有newCode，intermediate接口会报错，提示用户name，newCode，intermediate方便快速定位排查
    if (!newCode && !intermediate) {
      $notify.error(`pageName: ${to?.name}，nowCode: ${newCode}，intermediate: ${intermediate}`, {
        ternimal: false
      });
    }
    request_url = '?root=iWMS&resourceNo=' + newCode + '&intermediate=' + intermediate + '&_t_=' + new Date().getTime()
  } else {
    let code = to?.meta?.code;
    let intermediate = to?.meta?.intermediate;
    // 如果没有newCode，intermediate接口会报错，提示用户name，newCode，intermediate方便快速定位排查
    if (!code && !intermediate) {
      $notify.error(`pageName: ${to?.name}，code: ${code}，intermediate: ${intermediate}`, {
        ternimal: false
      });
    }
    request_url = '?resourceNo=' + code + '&intermediate=' + intermediate + '&_t_=' + new Date().getTime()
  }
  axios.get(restUrls.check_resource_url + request_url, {
    timeout: 60000,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  }).then(response => {
    // todo 通过code来判断是否要跳转登录页面
    console.log('response', response);
    if (response?.data?.code === 409) {
      // 重新登录
      window.location.href = Cookies.get('lwms.logout.url') + "?ReturnUrl=" + encodeURIComponent(window.location.href)
      return;
    }
    let s = Cookies.get('lwms.layout.show')
    if (_.isEmpty(s) || s != '0') {
      s = decodeURIComponent((new RegExp('[?|&]s=([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
      if (!_.isEmpty(s) && s == '0') {
        Cookies.set('lwms.layout.show', '0', { domain: domain() })
      }
    }

    let x = response.data
    try {
      if (_.isString(x)) {
        x = JSON.parse(x)
      }
      let cookieName = 'lwms.router.name.of.referer'
      if (_.has(x, 'resultCode')) {
        if (!(x.resultCode == 1 && x.resultValue == 'true')) {
          console.log('access denied.')
          $alert('unauthorized', () => router.push({ name: 'unauthorized' }))
          return
        }
        if (!_.isEmpty(userInfo) && !_.isEmpty(userInfo.userCode) && !_.isEmpty(userInfo.orgNo) && !_.isEmpty(userInfo.distributeNo) && !_.isEmpty(userInfo.warehouseNo)) {
          addLog('pageJump', '切换页面', {
            to: to?.path,
            from: from?.path
          })
          next()
          return
        }
        console.log('first request: userInfo is empty')
        let refererRouterName = Cookies.get(cookieName)
        if (!_.isEmpty(refererRouterName)) {
          Cookies.remove(cookieName, { domain: domain() })
          window.location.replace(window.location.href.replace(from.path, to.path))
        }
        window.location.reload(true)
        return
      }
      if (x.code == 302) {
        window.location.href = x.data + '?ReturnUrl=' + encodeURIComponent(window.location.href)
        return
      }
      if (x.code == 401) {
        // window.mainVm.$store.commit('LOGIN_MODEL', true)
        window.location.href = x.data + '?ReturnUrl=' + encodeURIComponent(window.location.href)
        return
      }
      if (x.code == 300) {
        // history 模式下路由信息在 pathname+search 中，hash 恒为空，改用 search 保留当前路由参数
        window.location.href = x.data + window.location.pathname + window.location.search
        return
      }
      if (x.code == 301) {
        console.log('not belong to any tenant')
        const loginType=Cookies.get('lwms.lt')?Cookies.get('lwms.lt'):'b'
        if(loginType==='erp'){
          window.location.href = Cookies.get('lwms.logout.url') + "?ReturnUrl=" + encodeURIComponent(window.location.href) + `&bLoginType=${loginType}`
        }
        return $alert('notBelongToAnyTenant', () => router.push({ name: 'unauthorized' }))
      }
      if (x.code == 303) {
        Cookies.set(cookieName, to.name, { domain: domain() })
        router.push({ name: 'selectWarehouse' })
        return
      }
      if (x.code == 403) {
        const loginType=Cookies.get('lwms.lt')?Cookies.get('lwms.lt'):'b'
        if(loginType==='erp'){
          window.location.href = Cookies.get('lwms.logout.url') + "?ReturnUrl=" + encodeURIComponent(window.location.href) + `&bLoginType=${loginType}`
        }
        axios.get(restUrls.check_spm_user_identity_url + '?_t_=' + new Date().getTime(), {
          timeout: 60000,
          headers: { 'X-Requested-With': 'XMLHttpRequest'}
        }).then(result => {
          let y = result.data
          let tips = 'employeeUnbindAnyWarehouse'
          let nextRouterName = 'unauthorized'
          console.log('当前页面url: ' + window.location.href + '，请求url：' + restUrls.check_spm_user_identity_url + ', 返回：' + JSON.stringify(y))
          if (y.resultCode == 100000151) {
            $alert('memuOrderStatusForError')
            return
          }
          if (y.resultCode == 1) {
            tips = 'managerUnbindAnyWarehouse'
            nextRouterName = 'userWarehouseRelMaintain'
          }
          $alert(tips, () => router.push({ name: nextRouterName }))
        }).catch(ex => {
          $alert(errorContent)
        })
      }
    } catch (error) {
      console.log(error)
      $alert(errorContent)
    }
  }, error => {
    console.log(error)
    $alert(errorContent)
    return Promise.reject(error)
  }).catch(error => {
    console.log(error?.message)
    $alert(errorContent)
  })

})
router.afterEach((to, from, next) => {
  if (env !== 'test' && getCurrentSiteEnv() !== 'test') {
    // performanceMonitoring.changeRoute(); // 异常监控上报
  }
  // if(to.path !=='/index' && window.closeCsatDialog) {
  //   window.closeCsatDialog()
  // }
  // 路由下发子应用（对齐 scg-fe scm-scg router 的 nextHandler）：
  // 主应用跳到 /pages-xxx/* 时，剥掉前缀，把子路径通过 microApp.setData 下发给对应子应用，
  // 子应用收到 routerPush 后用 microPush 真正跳转。
  const pathMatch = to.path.match(/^\/pages[^/]+\//)
  const appName = pathMatch ? pathMatch[0].replace(/\//g, '') : null
  if (appName && microApp && typeof microApp.setData === 'function') {
    const childPath = to.path.replace(/^\/pages[^/]+/, '') || '/'
    microApp.setData(appName, {
      type: 'routerPush',
      data: {
        path: childPath,
        query: to.query || {},
        params: to.params || {}
      }
    })
  }
})

export default router
